import {
    clampQuantityValue,
    initQuantitySteppers,
    parseQuantityInputValue,
    readQuantityStepperBounds,
} from './quantity-stepper';

window.addEventListener('DOMContentLoaded', function () {
    const parseNumber = function (value) {
        return Number(String(value ?? '').replace(/[^\d.-]/g, '')) || 0;
    };

    const updateSubtotal = function (input) {
        const row = input.closest('tr');
        if (!row) {
            return;
        }

        const unitPriceText = row.querySelector('.js-product-options-unit')?.textContent ?? '0';
        const unitPrice = parseNumber(unitPriceText);
        const quantity = parseNumber(input.value);
        const subtotal = unitPrice * quantity;
        const subtotalElement = row.querySelector('.js-product-options-subtotal');

        if (!subtotalElement) {
            return;
        }

        const format = subtotalElement.dataset.format ?? 'number';
        const suffix = subtotalElement.dataset.suffix ?? '';

        subtotalElement.textContent = format === 'currency'
            ? `${subtotal.toLocaleString('ja-JP')}${suffix}`
            : subtotal.toLocaleString('ja-JP');
    };

    initQuantitySteppers(document, {
        onChange: (input) => {
            updateSubtotal(input);
        },
    });

    document.querySelectorAll('form').forEach(function (form) {
        if (!form.querySelector('.js-product-options-qty')) {
            return;
        }
        form.addEventListener('submit', function () {
            form.querySelectorAll('[data-quantity-stepper]').forEach(function (stepperRoot) {
                const quantityInput = stepperRoot.querySelector('[data-quantity-stepper-input]');
                if (!(quantityInput instanceof HTMLInputElement)) {
                    return;
                }

                const { min, max } = readQuantityStepperBounds(stepperRoot);
                if (quantityInput.value === '' || quantityInput.value === null) {
                    quantityInput.value = '0';
                } else {
                    quantityInput.value = String(
                        clampQuantityValue(parseQuantityInputValue(quantityInput.value), min, max),
                    );
                }
            });
        });
    });
});
